/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Limit} from '../models/Limit';
import type {UserLimitsRemoveRequest} from '../models/UserLimitsRemoveRequest';
import type {UserLimitsSaveRequest} from '../models/UserLimitsSaveRequest';

export interface GetUserSearchLimits$Request {
    userId: number;
}

export interface GetUserSearchLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserSearchLimitsRequest = createAction<PayloadData<void, GetUserSearchLimits$Request>>('USER_SEARCH_LIMITS__GET_USER_SEARCH_LIMITS__REQUEST');
export const getUserSearchLimitsSuccess = createAction<PayloadData<Array<Limit>, GetUserSearchLimits$Request>>('USER_SEARCH_LIMITS__GET_USER_SEARCH_LIMITS__SUCCESS');
export const getUserSearchLimitsFailure = createAction<PayloadData<Error, GetUserSearchLimits$Request, true>>('USER_SEARCH_LIMITS__GET_USER_SEARCH_LIMITS__FAILURE');

export const getUserSearchLimitsActions = [
    getUserSearchLimitsRequest,
    getUserSearchLimitsSuccess,
    getUserSearchLimitsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserSearchLimits = (meta: GetUserSearchLimits$Request, config?: GetUserSearchLimits$Config) => {
    return {
        CALL_API: {
            types: getUserSearchLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/searches-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveUserSearchLimit$Request {
    userId: number;
    userLimitsRemoveRequest: UserLimitsRemoveRequest;
}

export interface RemoveUserSearchLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeUserSearchLimitRequest = createAction<PayloadData<void, RemoveUserSearchLimit$Request>>('USER_SEARCH_LIMITS__REMOVE_USER_SEARCH_LIMIT__REQUEST');
export const removeUserSearchLimitSuccess = createAction<PayloadData<void, RemoveUserSearchLimit$Request>>('USER_SEARCH_LIMITS__REMOVE_USER_SEARCH_LIMIT__SUCCESS');
export const removeUserSearchLimitFailure = createAction<PayloadData<Error, RemoveUserSearchLimit$Request, true>>('USER_SEARCH_LIMITS__REMOVE_USER_SEARCH_LIMIT__FAILURE');

export const removeUserSearchLimitActions = [
    removeUserSearchLimitRequest,
    removeUserSearchLimitSuccess,
    removeUserSearchLimitFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLimitsRemoveRequest} meta.userLimitsRemoveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeUserSearchLimit = (meta: RemoveUserSearchLimit$Request, config?: RemoveUserSearchLimit$Config) => {
    return {
        CALL_API: {
            types: removeUserSearchLimitActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/users/${meta.userId}/searches-limits`,
            TRANSPORT_REQUEST_BODY: meta.userLimitsRemoveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserSearchLimit$Request {
    userId: number;
    userLimitsSaveRequest: UserLimitsSaveRequest;
}

export interface SaveUserSearchLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserSearchLimitRequest = createAction<PayloadData<void, SaveUserSearchLimit$Request>>('USER_SEARCH_LIMITS__SAVE_USER_SEARCH_LIMIT__REQUEST');
export const saveUserSearchLimitSuccess = createAction<PayloadData<void, SaveUserSearchLimit$Request>>('USER_SEARCH_LIMITS__SAVE_USER_SEARCH_LIMIT__SUCCESS');
export const saveUserSearchLimitFailure = createAction<PayloadData<Error, SaveUserSearchLimit$Request, true>>('USER_SEARCH_LIMITS__SAVE_USER_SEARCH_LIMIT__FAILURE');

export const saveUserSearchLimitActions = [
    saveUserSearchLimitRequest,
    saveUserSearchLimitSuccess,
    saveUserSearchLimitFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLimitsSaveRequest} meta.userLimitsSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserSearchLimit = (meta: SaveUserSearchLimit$Request, config?: SaveUserSearchLimit$Config) => {
    return {
        CALL_API: {
            types: saveUserSearchLimitActions,
            method: ApiMethods.PATCH,
            endpoint: `/web-api/users/${meta.userId}/searches-limits`,
            TRANSPORT_REQUEST_BODY: meta.userLimitsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

